import React from 'react';
import { componentVariants } from '../../config';

const Card = ({ children, className = '', ...props }) => {
  const { base } = componentVariants.card;
  
  return (
    <div 
      className={`${base} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '' }) => {
  const { header } = componentVariants.card;
  
  return (
    <div className={`${header} ${className}`}>
      {children}
    </div>
  );
};

const CardContent = ({ children, className = '' }) => {
  const { content } = componentVariants.card;
  
  return (
    <div className={`${content} ${className}`}>
      {children}
    </div>
  );
};

const CardFooter = ({ children, className = '' }) => {
  const { footer } = componentVariants.card;
  
  return (
    <div className={`${footer} ${className}`}>
      {children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;
